<template>
	<div :class="'emoji-code-' + type" class="emoji-code">
		<img :src="emojis[intCode - 1]" v-if="intCode > 0">
	</div>
</template>

<script>
	import emojis from './emojis.js'

	const emojiTranslation = {
		'1': 'Clock',
		'2': 'Flower',
		'3': 'Heart',
		'4': 'Pizza',
		'5': 'Popsicle',
		'6': 'Shrimp',
		'7': 'Smiley',
		'8': 'Sun',
		'9': 'Car',
	};

	export default {
		name: 'single-emoji-code',
		props: {
			code: {
				required: true
			},
			type: {
				type: String,
				required: false,
				default: 'default'
			}
		},
		data() {
			return {
				emojis: emojis
			}
		},
		computed: {
			intCode() {
				return parseInt(this.code, 10)
			}
		}
	}
</script>
<style lang="less" scoped>
	@import "~@less/mixins/mixins.less";

	.emoji-code {
		width: 65px;
		height: 65px;
		display: inline-block;
		text-align: center;
		background: @whiteish;
		margin: 10px;
		// border: solid black 1px;
		position: relative;
		.unSelectable();

		&:first-child {
			margin-left: 0 !important;
		}

		&:last-child {
			margin-right: 0 !important;
		}

		&.emoji-code-tiny {
			width: 50px;
			height: 50px;
			margin: 5px;
		}

		&.emoji-code-large {
			width: 100px;
			height: 100px;
			margin: 20px;
		}

		img {
			position: absolute;

			max-width: 80%;
			max-height: 80%;

			top: 50%;
			left: 50%;
			transform: translateX(-50%) translateY(-50%);
		}
	}
</style>